export default __webpack_public_path__ + "static/telegram-8ff3d669f74175a4a8158f3ad86042b7.svg";